const validate = (values) => {
  const errors = {};
  if (!values.name) {
    errors.name = 'Esse campo não pode ficar vazio';
  }
  if (!values.startTime) {
    errors.startTime = 'Esse campo não pode ficar vazio';
  }
  if (!values.endTime) {
    errors.endTime = 'Esse campo não pode ficar vazio';
  }
  if (!values.url) {
    errors.url = 'Esse campo não pode ficar vazio';
  }
  return errors;
};

export default validate;
